import(/* webpackMode: "eager" */ "/home/watchero/watchero-servers/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/watchero/watchero-servers/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/watchero/watchero-servers/packages/watchero.io/components/shared/blur-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/home/watchero/watchero-servers/packages/watchero.io/components/shared/copy-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardTableOfContents"] */ "/home/watchero/watchero-servers/packages/watchero.io/components/shared/toc.tsx");
;
import(/* webpackMode: "eager" */ "/home/watchero/watchero-servers/packages/watchero.io/public/_static/og.jpg");
;
import(/* webpackMode: "eager" */ "/home/watchero/watchero-servers/packages/watchero.io/styles/mdx.css");
